import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import MdCallEnd from 'react-icons/lib/md/call-end'
import MdCall from 'react-icons/lib/md/call'
import useTwilioDevice from 'App/hooks/useTwilioDevice'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import {Fragment} from 'react'

export default function Call({match}) {
  const {token} = match.params

  const {numberCallInfo} = useQuery({
    query: gql`
      query numberCallInfo($token: String) {
        numberCallInfo(token: $token) {
          name
          phone
          callingCapabilityToken
          userId
          userFullName
        }
      }
    `,
    variables: {token}
  })

  const {currentCallPhoneNumber, makeCall, stopCall} = useTwilioDevice({
    callingCapabilityToken: numberCallInfo.callingCapabilityToken,
    _id: numberCallInfo.userId,
    fullName: numberCallInfo.userFullName
  })

  const backApp = () => {
    window.close()
  }

  if (!numberCallInfo) {
    return (
      <div>
        <div>Ocurrió un error</div>
        <Button onClick={backApp} icon={MdCallEnd} big danger>
          Volver
        </Button>
      </div>
    )
  }

  const isCalling = currentCallPhoneNumber === numberCallInfo.phone

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.name}>{numberCallInfo.name}</div>
        {isCalling ? (
          <Fragment>
            <div className={styles.activePhone}>
              <MdCall className={styles.icon} />
            </div>
            <div className={styles.time}>Llamada en curso...</div>
          </Fragment>
        ) : (
          <Fragment>
            <div className={styles.activePhone}>
              <MdCall className={styles.icon} />
            </div>
            <div className={styles.time}>Haz click para comenzar la llamada</div>
          </Fragment>
        )}

        <Button
          onClick={() => {
            if (isCalling) {
              stopCall()
              backApp()
            } else {
              makeCall(numberCallInfo.phone)
            }
          }}
          icon={MdCallEnd}
          big
          primary={!isCalling}
          danger={isCalling}>
          {isCalling ? 'Colgar' : 'Llamar'}
        </Button>
      </div>
    </div>
  )
}
